import { Edit20Regular } from '@fluentui/react-icons';
import { SkillsStatusIndicator } from '../../SkillsStatusIndicator/SkillsStatusIndicator';
import {
  MySkillsStatusIndicatorMobileWrapper,
  SkillsItemHeader,
  MySkillsMobileListContainer,
  SkillItemTitle,
  MySkillsMobileLevelAndAttitude,
  EditButtonMobile,
} from '../styles/SkillsMainContainer.styled';
import {
  EmployeeSkill,
  EmployeeSkillsByCategoryDTO,
} from 'src/tabs/models/SkillsInterfaces';

interface SkillsItemMobileProps {
  setSelectedCategory: React.Dispatch<React.SetStateAction<string>>;
  setSelectedSkillToEdit: React.Dispatch<React.SetStateAction<EmployeeSkill>>;
  getEmployeeSkillById: (skillId: string) => Promise<void>;
  setEditSkillPopup: React.Dispatch<React.SetStateAction<boolean>>;
  skill: EmployeeSkill;
  skillDTO: EmployeeSkillsByCategoryDTO;
}

export const SkillsItemMobile = ({
  getEmployeeSkillById,
  setEditSkillPopup,
  setSelectedCategory,
  setSelectedSkillToEdit,
  skill,
  skillDTO,
}: SkillsItemMobileProps) => {
  return (
    <>
      <MySkillsStatusIndicatorMobileWrapper>
        <SkillsStatusIndicator
          requestedAttitude={skill.requestedAttitude?.label}
          requestedLevel={skill.requestedLevel?.label}
          validatedBy={skill.validatedBy}
          validatedDate={skill.validatedDate}
          status={skill.requestedAttitude || skill.requestedLevel ? '2' : '1'}
        />
      </MySkillsStatusIndicatorMobileWrapper>
      <SkillsItemHeader>
        <MySkillsMobileListContainer>
          <SkillItemTitle>{skill.skill.name}</SkillItemTitle>
          <MySkillsMobileLevelAndAttitude>
            Level{' '}
            {skill.validatedDate
              ? skill.level?.label
              : skill.requestedLevel.label || ''}{' '}
            • Attitude:{' '}
            {skill.validatedDate
              ? skill.attitude?.label
              : skill.requestedAttitude.label || ''}
          </MySkillsMobileLevelAndAttitude>
        </MySkillsMobileListContainer>
        <EditButtonMobile
          onClick={() => {
            setSelectedCategory(skillDTO.category.label);
            setSelectedSkillToEdit(skill);
            getEmployeeSkillById(skill.id);
            setEditSkillPopup(true);
          }}
        >
          <Edit20Regular />
        </EditButtonMobile>
      </SkillsItemHeader>
    </>
  );
};
